import { Box } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AmendsBoundaryEditor } from "authoring/routes/project/amends/components/amends-boundary-editor"

export function PreviewTaskAmends() {
    const { task, target, editMode, amendsContext, getTaskAmendsKey } = useBoundContext()
    if (editMode) return null
    if (!amendsContext || !getTaskAmendsKey) return null

    const contextTarget = target ?? task
    const amendsKey = getTaskAmendsKey(contextTarget)
    if (!amendsKey) return null

    const state = amendsContext.getAmendsState(amendsKey)
    if (!state.hasSavedAmends) return null

    return (
        <Box sx={{ pl: { xs: 2, sm: 5 }, pr: 2, pb: 2, pt: 1 }}>
            <AmendsBoundaryEditor amendsKey={amendsKey} alwaysOpen />
        </Box>
    )
}
